import { IsDefined, IsEmail, IsNotEmpty, MinLength } from 'class-validator';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Redirect } from 'react-router';
import { UserApi } from '@intelingu/core/api/UserApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { IsEqualTo } from '@intelingu/core/validators/decorators/IsEqualTo';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import Logger from '@intelingu/core/utils/Logger';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { SubmitButton } from '../../../partials/form/elements/SubmitButton';
import { TextInput } from '../../../partials/form/elements/TextInput';
import { Field } from '@intelingu/core/components/form/Field';
import { Form } from '@intelingu/core/components/form/Form';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';

export interface ChangePasswordPageProps {
    t?;
}

class ChangePasswordRequest {

    token: string;

    @MinLength(6)
    password: string;

    @IsEqualTo('password', {
        message: 'passwords are not equal'
    })
    password_repeat: string;

}

@withTranslation(COMMON_NS)
@observer export class ChangePasswordPage extends Component<ChangePasswordPageProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(UserApi) userApi: UserApi;

    @observable isError = false;
    @observable isDone = false;

    @action.bound async reset(data: ChangePasswordRequest, done) {
        // const { email } = data;

        try {
            this.isError = false;
            await this.userApi.setNewPassword(data);

            this.isDone = true;
        } catch (e) {
            this.isError = true;

            Logger.error(e);
        } finally {
            done();
        }
    }

    render() {
        const { t } = this.props;

        if (this.isDone) {
            return <Redirect to={{
                pathname: `/session/login`,
                state: {
                    alert: t('sessionPasswordChangedMessage')
                }
            }} />
        }

        return <div className={'session-page'}>
            <>
                <h1>{ t('sessionChangePasswordTitle') }</h1>

                <p>
                    { t('sessionEnterNewPasswordText') }
                </p>

                <div className={'sep'} />

                <Form validator={ChangePasswordRequest} onSubmit={this.reset}>
                    <FormGroup>
                        <Label for="password">{ t('sessionPassword') }</Label>

                        <Field
                            name={'password'}
                            render={props => <TextInput type={'password'} {...props} />}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="password">{ t('sessionRepeatPassword') }</Label>

                        <Field
                            name={'password_repeat'}
                            render={props => <TextInput type={'password'} {...props} />}
                        />
                    </FormGroup>

                    { this.isError && (
                        <div className={'alert alert-danger'}>
                            { t('sessionResetLinkExpired') }
                        </div>
                    )}

                    <FormGroup style={{ marginTop: 20 }}>
                        <Field submit render={props => <SubmitButton className={'outline'} {...props}>{ t('sessionRepeatPassword') }</SubmitButton>} />
                    </FormGroup>
                </Form>
            </>
        </div>
    }

}
